import useSourceType from "@/hooks/useSourceType";
import STableLayout from "@/styles/STableLayout";
import SText from "@/styles/SText";
import { OrderV2 } from "@/types/inventoryV2";
import { dateFormat } from "@/utils/format";
import { Flex, Modal, TableProps, Typography } from "antd";
import { AnyObject } from "antd/es/_util/type";
import dayjs from "dayjs";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
interface OutOrdersListPrps {
  open: boolean;
  number: string;
  list: OrderV2[];
  onClose: () => void;
  btns?: ReactNode;
}
const OutOrdersList: FC<OutOrdersListPrps> = ({ open, number, list, onClose, btns }) => {
  const { t } = useTranslation();
  const { getChangeType, getOpType } = useSourceType();

  const columns: TableProps<OrderV2>["columns"] = [
    {
      title: t('warehouse.outNo'),
      dataIndex: "number",
      key: "number",
      width: 200,
      fixed: "left",
      ellipsis: true,
      sorter: (a, b) => {
        const valA = a?.number ?? "";
        const valB = b?.number ?? "";
        return valA.localeCompare(valB);
      },
      render(value, record, index) {
        return <Typography.Link >{record.number}</Typography.Link>
      },
    },
    {
      title: t('order.preparationTime'),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (_, record) => record.createdAt && dateFormat(dayjs(record.createdAt)),
    },
    {
      title: t('order.confirmedTime'),
      dataIndex: "confirmedAt",
      key: "confirmedAt",
      width: 100,
      render: (confirmedAt) => confirmedAt && dateFormat(dayjs(confirmedAt)),
    },
    {
      title: t('order.oprtType'),
      key: "type",
      dataIndex: "type",
      width: 120,
      fixed: "right",
      render: (_, { type, id }) => {
        let info = getChangeType(type);
        return (
          <SText text={info?.label ?? ""} tagMode color={info?.color} />
        );
      },
    },
    {
      title: t('order.operationSource'),
      key: "opType",
      dataIndex: "opType",
      width: 90,
      fixed: "right",
      render: (_, { opType, id }) => {
        let info = getOpType(opType);
        return (
          <SText text={info?.label ?? ""} tagMode color={info?.color} />
        );
      },
    },
    {
      title: t('order.operationStatus'),
      key: "confirmState",
      dataIndex: "confirmState",
      width: 90,
      fixed: "right",
      render: (_, { confirmState, id }) => {
        const label = confirmState === 0 ? t('order.preparing') : t('order.outboundCompleted');
        const color = confirmState === 0 ? 'orange' : 'green';
        return <SText text={label ?? ""} tagMode color={color} />
      },
    },
  ];
  return (
    <Modal title={
      <Flex style={{ width: "100%" }} gap={8} >
        <Typography.Title level={5} style={{ margin: 0 }} >
          {number + ' ' + t('common.oo')}
        </Typography.Title>
        {btns}
      </Flex>
    }
      open={open}
      width={1000}
      onCancel={onClose}
      footer={null}
      centered
    >
      <Flex vertical style={{ height: "40vh" }} >
        <STableLayout
          total={list.length}
          dataSource={list}
          pagination={false}
          extHeight={100}
          columns={columns as Array<AnyObject>}
          headerChildren={null}
        />
      </Flex>
    </Modal >
  )
};

export default OutOrdersList;